import { Component } from 'react';
import { withRouter } from 'react-router-dom';

class RouteTracker extends Component {
    componentWillReceiveProps(route) {
        if(process.env.NODE_ENV === 'development') {
            return;
        }
        const path = route.location.pathname;
        const mixpanel = window.mixpanel;
        const keen = window.keenClient;

        if (mixpanel) {
            mixpanel.track("pageview", {
                user: window.userGuid,
                url: path,
                email: window.email
            });
        }
        if (keen) {
            keen.recordEvent('pageview', {
                user: window.userGuid,
                url: path,
                email: window.email
            });
        }

    }
    render() {
        return this.props.children
    }
}

export default withRouter(RouteTracker);


// WEBPACK FOOTER //
// ./src/components/RouteTracker.js